module.exports = __webpack_public_path__ + "static/media/icon-menu.3b3e3510.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview/icon-menu.svg
// module id = ./src/assets/images/preview/icon-menu.svg
// module chunks = 6